module.exports = __webpack_public_path__ + "static/img/11.8b32fff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/11.png
// module id = MJEZ
// module chunks = 0